<sb-dashboard-widget [hasHeader]="false" [fixedHeight]="false">
  <div
    class="flex h-12 items-center gap-sm border-0 border-b border-solid border-default border-t-transparent pr-sm pl-md"
  >
    <h3 class="reset-h text-base font-semibold text-default">{{ title() }}</h3>
    @if (badge(); as badge) {
      <sb-badge [color]="badge.color" variant="pill">
        @if (badge.isLocked) {
          <sb-icon name="lock-regular" />
        }
        @if (badge.isLocked) {
          {{ 'HR Pro' | translate }}
        } @else {
          {{ badge.label }}
        }
      </sb-badge>
    }
    @if (scopeLocation()) {
      <span class="ms-auto text-sm text-subtle">{{
        '[location] only' | translate: { location: scopeLocation() }
      }}</span>
    }
  </div>
  <div class="h-72 overflow-y-auto" tabindex="0" role="region" [attr.aria-label]="title()">
    @switch (state()) {
      @case ('loading') {
        <sb-loading-state class="size-full" />
      }
      @case ('error') {
        <sb-empty-state class="size-full" icon="alert-cute-re" [description]="errorMessage()">
          <button sb-button type="button" (click)="retry.emit()">{{ 'Try again' | translate }}</button>
        </sb-empty-state>
      }
      @case ('locked') {
        <sb-empty-state
          class="size-full"
          icon="user-add-cute-re"
          [description]="
            'Onboarding, contracts and file reviews run in HR Pro. Add it to see what needs you here.' | translate
          "
        >
          <button sb-button type="button" (click)="unlock.emit()">{{ 'See what HR Pro does' | translate }}</button>
        </sb-empty-state>
      }
      @case ('clear') {
        <sb-empty-state class="size-full" icon="check-circle-cute-re" [description]="clearMessage()" />
      }
      @case ('ready') {
        <ul class="reset-ul">
          <ng-content />
        </ul>
      }
    }
  </div>
</sb-dashboard-widget>
